import BannerAward2024 from '../img/banner/Award2024.png';
import Logo from '../img/event/2610/logo.png';
import Title from '../img/event/2610/title.png';
import Box from '../img/event/2610/box.png';
import TargetBox1 from '../img/event/2610/target-box1.png';
import TargetBox2 from '../img/event/2610/target-box2.png';
import TargetBox3 from '../img/event/2610/target-box3.png';
import Title2 from '../img/event/2610/title2.png';
import BackgroundImage from '../img/event/2610/background-image.png';
import Online_Session from '../img/event/online-session.png';
import { DoubleLineWithCursorButton, DoubleLineButton } from './common/Button';
import React from 'react';
import { TextBox } from './common/TextBox';

const HomeschoolEvent202610 = () => {
  return (
    <>
      {/* 배너 영역 */}
      <img src={BannerAward2024} alt="Award2024" className="m-auto w-full" />

      {/* 프로모션 섹션 1 */}
      <div className="flex w-full items-center justify-center overflow-hidden bg-[#FF6600]">
        <div className="flex w-full flex-col px-4 py-6 sm:px-6 sm:py-10 md:px-8 md:py-14 lg:px-10 lg:py-16">
          <div className="mx-auto mb-4 flex w-full flex-col items-center justify-center">
            {/* 로고 */}
            <div className="mx-auto w-full max-w-[110px] sm:max-w-[130px] md:max-w-[150px] lg:max-w-[170px]">
              <img src={Logo} alt="젭스 영어교실" className="block w-full" />
            </div>

            {/* 메인 타이틀 이미지 */}
            <div className="mt-6 w-full max-w-[320px] sm:mt-12 sm:max-w-[400px] md:mt-16 md:max-w-[480px] lg:mt-20 lg:max-w-[560px]">
              <img
                src={Title}
                alt="1010 MONTH 텐텐먼스"
                className="block w-full"
              />
            </div>

            <div>
              <p className="mt-6 text-center text-lg font-bold leading-relaxed text-white sm:text-xl md:text-2xl lg:text-3xl">
                10월 한 달 간,
                <br />
                <span className="text-black">10점 만점 혜택!</span>
              </p>
            </div>

            {/* 말풍선 이미지 */}
            <div className="mt-8 w-full max-w-[285px] sm:mt-9 sm:max-w-[360px] md:mt-11 md:max-w-[440px] lg:mt-12 lg:max-w-[500px]">
              <img
                src={Box}
                alt="최대 10만 포인트 페이백! 영어 기본기 특강 2개월 무료! e-러닝 복습 시스템 업그레이드"
                className="block w-full"
              />
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 2 */}
      <div className="flex w-full items-center justify-center overflow-hidden bg-[#000000]">
        <div className="flex w-full flex-col px-5 py-8 sm:px-8 sm:py-12 md:px-10 md:py-16 lg:py-20">
          <div className="mx-auto flex w-full flex-col items-center justify-center">
            <div className="my-6 flex flex-col items-center text-center sm:my-10 md:my-12">
              <div>
                <p className="text-lg font-bold leading-relaxed text-white sm:text-xl md:text-2xl lg:text-3xl">
                  오직 젭스만이 가진, 압도적인 노하우로
                  <br />
                  믿음 영어&nbsp;
                  <span className="text-[#FF6600]">지원 사격!</span>
                </p>
              </div>

              <div className="mt-10 flex flex-col items-center gap-6 sm:mt-12 md:mt-16 lg:mt-20">
                <div className="w-full max-w-[220px] sm:max-w-[260px] md:max-w-[330px] lg:max-w-[400px]">
                  <img
                    src={TargetBox1}
                    alt="암기 명중"
                    className="block w-full"
                  />
                </div>

                <p className="text-base leading-relaxed text-white sm:text-lg md:text-xl lg:text-2xl">
                  <span className="text-[#FAF590]">특허받은 삽화기억술</span>로
                  재밌고 쉽게!
                  <br />
                  <span className="text-[#FAF590]">청크 학습</span>으로
                  바이블스토리&nbsp;
                  <span className="text-[#FAF590]">1200문장 암송!</span>
                </p>
              </div>

              <div className="mt-10 flex flex-col items-center gap-6 sm:mt-12 md:mt-16 lg:mt-20">
                <div className="w-full max-w-[220px] sm:max-w-[260px] md:max-w-[330px] lg:max-w-[400px]">
                  <img
                    src={TargetBox2}
                    alt="실력 명중"
                    className="block w-full"
                  />
                </div>

                <p className="text-base leading-relaxed text-white sm:text-lg md:text-xl lg:text-2xl">
                  <span className="text-[#FAF590]">AI 스피킹 인증</span>으로,
                  애매하지 않게 확실하게!
                  <br />
                  <span className="text-[#FAF590]">e러닝 복습 시스템</span>으로
                  완전히 내 것으로!
                </p>
              </div>

              <div className="mt-10 flex flex-col items-center gap-6 sm:mt-12 md:mt-16 lg:mt-20">
                <div className="w-full max-w-[220px] sm:max-w-[260px] md:max-w-[330px] lg:max-w-[400px]">
                  <img
                    src={TargetBox3}
                    alt="비전 명중"
                    className="block w-full"
                  />
                </div>

                <p className="text-base leading-relaxed text-white sm:text-lg md:text-xl lg:text-2xl">
                  영어를 배우는 진짜 이유,&nbsp;
                  <span className="text-[#FAF590]">하나님 영광을 위해!</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 3 */}
      <div className="flex w-full items-center justify-center overflow-hidden bg-[#FFF9F2]">
        <div className="m-auto flex w-full flex-col px-5 py-10 sm:px-8 sm:py-14 md:px-10 md:py-16 lg:py-20">
          <div className="m-auto flex w-full max-w-[520px] flex-col gap-5 sm:gap-7 md:max-w-[620px] md:gap-8 lg:max-w-[720px]">
            {/* 설명회 타이틀 */}
            <section className="flex flex-col text-center sm:gap-1">
              <div className="text-lg font-semibold text-[#FF6600] sm:text-xl md:text-2xl lg:text-3xl">
                믿음도, 영어도 확실하게 성장하고 싶다면?
              </div>

              <div className="text-lg font-extrabold leading-snug text-[#000000] sm:text-2xl md:text-3xl lg:text-4xl">
                온라인 설명회에서 확인하세요!
              </div>
            </section>

            {/* 이미지 */}
            <div className="relative m-auto w-full max-w-[360px] sm:max-w-[460px] md:max-w-[560px] lg:max-w-[640px]">
              <img
                src={Online_Session}
                alt="젭스영어교실 온라인설명회"
                className="block w-full"
              />
            </div>

            {/* 버튼 */}
            <div className="mx-auto w-full max-w-[360px] sm:max-w-[460px] md:max-w-[560px] lg:max-w-[640px]">
              <DoubleLineButton
                onClick={() => {
                  window.open('https://forms.gle/hYg6Q4YQ4tMcBFb58');
                }}
                borderColor="border-white"
                bgColor="bg-gradient-to-r from-[#FF6600] from-[71%] to-[#F9C443] to-[100%]"
                hoverBgColor="hover:bg-black/10"
                textColor="text-[#FFFFFF]"
              >
                <div className="px-4 py-3 text-base font-bold sm:px-5 sm:py-4 sm:text-2xl md:text-3xl lg:text-4xl">
                  지금 설명회 신청하기
                </div>
              </DoubleLineButton>
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 4 */}
      <div className="flex w-full items-center justify-center bg-gray2">
        <div
          className="m-auto flex w-full flex-col bg-[#FF6600] bg-top bg-no-repeat px-5 py-10 sm:px-8 sm:py-14 md:px-10 md:py-16 lg:py-20"
          style={{
            backgroundImage: `url(${BackgroundImage})`,
            backgroundSize: '100% auto',
          }}
        >
          <div className="mx-auto w-full max-w-[520px] md:max-w-[620px] lg:max-w-[720px]">
            {/* 상단 문구 */}
            <div className="relative m-auto mb-8 w-full max-w-[360px] sm:mb-10 sm:max-w-[460px] md:mb-12 md:max-w-[560px] lg:max-w-[640px]">
              <img
                src={Title2}
                alt="믿음 영어 정말 될까요?"
                className="block w-full"
              />
            </div>

            <div className="mb-8 flex flex-col items-center text-center sm:mb-10 md:mb-12">
              <p className="text-base font-bold leading-relaxed text-white sm:text-xl md:text-2xl lg:text-3xl">
                직접 삶으로 증명하고 있는
                <br />
                젭스영어교실 선생님들의 이야기를
                <br />
                만나보세요!
              </p>
            </div>

            {/* 하단 박스 */}
            <section className="flex w-full flex-col gap-4 sm:gap-5 md:gap-6">
              <div className="grid grid-cols-1 gap-12 md:gap-14 lg:gap-16">
                <TextBox className="h-full">
                  <div className="flex flex-col gap-5 py-4 text-left text-base font-normal leading-relaxed text-black sm:text-xl md:gap-6 md:text-2xl lg:text-3xl">
                    <p>
                      <span className="font-bold text-[#FF6600]">
                        JEMM 최OO 선생님
                      </span>
                    </p>

                    <p className="leading-[1.7]">
                      알파벳도 모르는 아이들과
                      <br />
                      어떻게 시작할지 걱정이었지만,
                      <br />
                      <span className="font-bold">
                        기도하며 만들어진 프로그램이기에
                      </span>
                      <br />
                      <span className="font-bold">
                        하나님께 맡기고 가르쳤습니다.
                      </span>
                    </p>

                    <p className="leading-[1.7]">
                      그런데 아이들이 다른 과에서 배운 문장을
                      <br />
                      <span className="font-bold">
                        스스로 연결해 떠올릴 때마다
                      </span>
                      <br />
                      <span className="font-bold">
                        저도 모르게 깜짝 놀라곤 합니다.
                      </span>
                      <br />
                      아이들이 즐겁게 공부할 수 있음에,
                      <br />
                      젭스를 통해 아이들에게 복음을 전하게 하심에,
                      <br />
                      오늘도 감사합니다.
                    </p>
                  </div>
                </TextBox>

                <TextBox className="h-full">
                  <div className="flex flex-col gap-5 py-4 text-left text-base font-normal leading-relaxed text-black sm:text-xl md:gap-6 md:text-2xl lg:text-3xl">
                    <p>
                      <span className="font-bold text-[#FF6600]">
                        JEMM 김OO 선생님
                      </span>
                    </p>

                    <p className="leading-[1.7]">
                      교회를 다니지 않던 아이들이
                      <br />
                      <span className="font-bold">
                        "하나님이 만드셨어요"라고 고백하고,
                      </span>
                      <br />
                      발표를 어려워하던 아이가
                      <br />
                      <span className="font-bold">
                        이제는 자신 있게 암송하는 모습을 보며
                      </span>
                      <br />
                      젭스는 단순한 영어교육을 넘어,
                      <br />
                      <span className="font-bold">
                        영어와 신앙을 함께 세우는 귀한 통로
                      </span>
                      라는
                      <br />
                      생각이 듭니다.
                    </p>

                    <p className="leading-[1.7]">
                      <span className="font-bold">
                        '영어교육선교사'라는 사명을 붙잡고,
                      </span>
                      <br />
                      <span className="font-bold">
                        하나님 나라를 함께 확장해 나가길 소망합니다.
                      </span>
                    </p>
                  </div>
                </TextBox>
              </div>
            </section>

            <div className="m-auto flex w-full flex-col px-0 pb-0 pt-10 sm:pt-12 md:pt-14 lg:pt-16">
              <div className="flex flex-col gap-4 sm:gap-6 md:gap-8 lg:gap-10">
                <p className="text-center text-base font-extrabold text-white sm:text-xl md:text-2xl lg:text-3xl">
                  ‘영어교육선교사'로
                  <br />
                  첫걸음을 내딛는 순간,
                </p>

                <p className="text-center text-base font-extrabold text-white sm:text-xl md:text-2xl lg:text-3xl">
                  우리 아이는
                  <br />이 이야기의 주인공이 됩니다
                </p>

                <p className="text-center text-base font-extrabold text-black sm:text-xl md:text-2xl lg:text-3xl">
                  젭스영어교실
                  <br />
                  지금 바로 시작하세요!
                </p>
              </div>

              {/* 버튼 */}
              <div className="mx-auto mt-8 w-full max-w-[360px] sm:mt-10 sm:max-w-[520px] md:mt-12 md:max-w-[640px]">
                <DoubleLineWithCursorButton
                  onClick={() => {
                    window.open(
                      'https://jebs.kr/shop/details/NKyRTHjIgiewcumT',
                    );
                  }}
                  bgColor="bg-black"
                  hoverBgColor="hover:bg-black/70"
                  textColor="text-white"
                >
                  <div className="px-4 py-3 text-base font-bold sm:px-6 sm:py-4 sm:text-2xl md:text-3xl lg:px-8 lg:py-5 lg:text-3xl">
                    10월 젭스영어교실&nbsp;
                    <span className="text-[#FDF4B4]">등록하고 혜택 받기</span>
                  </div>
                </DoubleLineWithCursorButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeschoolEvent202610;
